import { Collapse } from '@chakra-ui/react';
import { Modal, ModalCloseButton, ModalContent, ModalOverlay } from '@chakra-ui/react';
import {
  BillableIcon,
  CalenderIcon,
  ChevronDownIcon,
  DeleteIcon,
  EditIcon,
  LeftArrowIcon,
  PlayCircle,
  StopCircle,
  TimeHourglassIcon,
} from '@sketchnote/icons';
import { Avatar, Button, Panel, Switch, Tabs } from '@sketchnote/shared-components';
import Tippy from '@tippyjs/react';
import TimeRangePicker from '@wojtekmaj/react-timerange-picker/dist/entry.nostyle';
import { format, formatISO, parseISO } from 'date-fns';
import { useRouter } from 'next/router';
import React, { useCallback, useEffect, useState } from 'react';
import { API } from 'src/api';
import { useTimerWidgetStore } from 'src/components/navbar/TimerWidget/useTimerWidgetStore';
import { useBoardStore } from 'src/features/boards';
import { useTaskAccess } from 'src/features/files/hooks/useTaskAccess';
import { useKanbanStore } from 'src/features/kanban';
import { calculateTimeInHours, getTimeDifference } from 'src/utils/date-time-functions';

import { useTasksStore } from '../store/useTasksStore';
import { TaskT } from '../types/tasks';
import { DateRangePicker } from './DatePicker';

type TimeLogEntry = {
  _id: string;
  duration: { hours: string; minutes: string; seconds: string };
  startDate: string;
  billable: boolean;
  description?: string;
  member?: {
    firstname: string;
    lastname: string;
    avatar: string;
    memberId: string;
    email: string;
  };
};

export const TimeLogDetails = ({
  isBillable,
  setIsBillable,
  description,
  setDescription,
}: {
  isBillable: boolean;
  setIsBillable: React.Dispatch<React.SetStateAction<boolean>>;
  description?: string;
  setDescription?: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const [label, setLabel] = useState();
  const [shouldAddLabel, setAddLabel] = useState<boolean>(false);
  const [shouldAddDescription, setAddDescription] = useState<boolean>(false);

  const { labels } = useKanbanStore((s) => ({
    labels: s.labels,
  }));

  const randomColor = [
    '#fbb6ce',
    '#d6bcfa',
    '#9BADEE',
    '#81e6d9',
    '#86E495',
    '#FFE98F',
    '#fbd38d',
    '#FBB1A7',
  ];

  // const handleChangeLabel: Creatable<
  //   { label: string; value: string; color?: string; id?: string },
  //   true
  // >['onChange'] = (options) => {
  //   const selectedLabels = options.map((item) =>
  //     item.color && item.id
  //       ? item
  //       : {
  //           label: item.label,
  //           value: item.value,
  //           color: randomColor[Math.floor(Math.random() * randomColor.length)],
  //           id: uuid(),
  //         }
  //   );
  // };

  return (
    <>
      {/* <div className="flex">
        {!shouldAddDescription && (
          <button
            className="flex items-center text-xs text-gray-400 font-medium mr-8 mb-16"
            onClick={() => setAddDescription(true)}
          >
            <DescriptionIcon className="mr-4" />
            <span>Add Description</span>
          </button>
        )}
        {!shouldAddLabel && (
          <button
            className="flex items-center text-xs text-gray-400 font-medium mb-16"
            onClick={() => setAddLabel(true)}
          >
            <LabelIcon className="mr-4" size={18} fill="none" />
            <span>Add Label</span>
          </button>
        )}
      </div> 
      {shouldAddDescription && (
        <div className="mb-8">
          <label className="text-gray-500">Add Description</label>
          <textarea
            placeholder="Write about the time log briefly"
            className="border border-gray-200 placeholder-gray-500 bg-gray-100 rounded p-10 mt-8 w-full"
          />
        </div>
      )}
      {shouldAddLabel && (
        <div className="mb-16">
          <label className="text-gray-500">Add Label</label>
          <CreatableSelect
            isClearable
            isMulti
            onChange={handleChangeLabel}
            menuPortalTarget={document.body}
            placeholder="Select label"
            className="mt-7"
            value={label}
            options={[
              {
                label: 'Select an option or create one',
                options: labels,
              },
            ]}
            components={{
              DropdownIndicator: UserSelectDropDownIndicator,
              IndicatorSeparator: () => null,
              NoOptionsMessage: LabelSelectNoOptions,
              SingleValue: LabelSelectSingleValue,
              Option: LabelSelectOption,
            }}
            styles={labelSelectStyles}
          />
        </div>
      )} */}
      <div className="text-sm text-gray-600 flex justify-between font-medium">
        <div className="flex items-center">
          <BillableIcon className="mr-4" fill="#55585E" />
          <span>Billable</span>
        </div>
        <Switch checked={isBillable} onChange={() => setIsBillable(!isBillable)} />
      </div>
      <div className="mt-8">
        <label className="text-gray-500">Add description</label>
        <textarea
          value={description}
          onChange={(e) => setDescription?.(e.target.value)}
          className="w-full resize-none border border-gray-200 rounded p-10 mt-8 bg-gray-100"
          rows={3}
          placeholder="Detail the time spent on task"
        />
      </div>
    </>
  );
};

const StartDateSelector = ({
  onSetStartDate,
  startDate,
}: {
  onSetStartDate: (dates: any) => void;
  startDate;
}) => {
  return (
    <div className="mb-16">
      <label htmlFor="assignDate" className="text-base mb-8 block text-gray-500 font-medium'">
        Select date
      </label>
      <div className="relative">
        <DateRangePicker
          value={startDate.length && startDate.map((date) => parseISO(date))}
          onChange={onSetStartDate}
          placeholderText="Select date"
          initialTab="date"
          show={['date']}
          disableEndDate={true}
          inputClassName="datepicker bg-gray-100 p-12 pl-50 w-full rounded-sm h-48 border border-gray-200 text-left text-gray-400"
        />
        <CalenderIcon
          wrapperClass="text-gray-400 absolute p-5 top-8 left-10 left-12 text-gray-400"
          size={30}
        />
      </div>
    </div>
  );
};

const TimeLogEntry = ({
  member,
  logs,
  totalTime,
  onExpand,
  isReadOnly,
}: {
  member: {
    firstname: string;
    lastname: string;
    avatar: string;
    memberId: string;
    email: string;
  };
  totalTime: number;
  logs: {
    duration: { hours: string; minutes: string; seconds: string };
    startDate: string;
    billable: boolean;
    description?: string;
  }[];
  onExpand: (e) => void;
  isReadOnly?: boolean;
}) => {
  const [show, setShow] = useState(false);
  const handleToggle = () => setShow(!show);

  const moreMenuItems = [
    {
      label: (
        <div className="flex font-regular text-gray-999 text-sm ">
          <EditIcon wrapperClass="mt-4 text-gray-500" />
          &nbsp;&nbsp; Edit
        </div>
      ),
      value: 'edit',
    },
    {
      label: (
        <button className="flex font-regular text-gray-999 text-sm ">
          <DeleteIcon wrapperClass="mt-4 text-gray-500" />
          &nbsp;&nbsp; Delete
        </button>
      ),
      value: 'delete',
    },
  ];

  const handleMenuItemClick = (e) => {
    if (e.value === 'delete') {
      // delete task
    } else if (e.value === 'edit') {
      //edit task
    }
  };

  return (
    <div>
      <div className="flex justify-between px-16 py-12 text-sm items-center">
        <button className="flex items-center align-middle" onClick={handleToggle}>
          <div
            style={{
              transform: show ? 'rotate(0deg)' : 'rotate(-90deg)',
              transition: 'all 0.5s',
            }}
            className="mr-6"
          >
            <ChevronDownIcon className="text-gray-500" />
          </div>
          <Avatar
            src={member.avatar}
            name={member.firstname}
            type="photo"
            wrapperClassName="mr-8"
          />
          <div>{member.firstname}</div>
        </button>
        <span className="text-gray-500">
          {calculateTimeInHours({ time: totalTime, format: 'clock' })}
        </span>
      </div>

      <Collapse in={show} className="overflow-auto no-scrollbar" style={{ overflow: 'auto' }}>
        {logs.map((log) => {
          return (
            <TimelogRow
              key={log.startDate}
              log={log}
              member={member}
              isReadOnly={isReadOnly}
              onExpand={onExpand}
            />
          );
        })}
      </Collapse>
    </div>
  );
};

const TimelogRow = ({
  log,
  member,
  onExpand,
  isReadOnly,
}: {
  log: {
    duration: { hours: string; minutes: string; seconds: string };
    startDate: string;
    billable: boolean;
    description?: string;
  };
  member: {
    firstname: string;
    lastname: string;
    avatar: string;
    memberId: string;
    email: string;
  };
  isReadOnly?: boolean;
  onExpand: (e) => void;
}) => {
  const [collapsed, setCollapsed] = useState(true);
  return (
    <div>
      <div
        className="flex p-10 px-16 bg-gray-100 justify-between text-sm border-b border-gray-300 cursor-pointer"
        onClick={() => setCollapsed(!collapsed)}
      >
        <div className="flex items-center">
          <span className="block mr-8 w-46 font-medium">{`${
            log.duration?.hours?.toString().padStart(2, '0') || '00'
          }:${log.duration?.minutes?.toString().padStart(2, '0') || '00'}`}</span>
          <span className=" text-xs text-gray-500 font-medium">
            {format(parseISO(log?.startDate), 'd MMM, ccc')}
          </span>
        </div>
        <div className="flex">
          <span className="mr-8 flex items-center">
            {/* <DescriptionIcon className="mr-4" />
                <LabelIcon fill="none" size={20} className="mr-4" /> */}
            {log.billable && (
              <Tippy content={'Billable'} className="z-200">
                <div className="flex">
                  <BillableIcon />
                </div>
              </Tippy>
            )}
          </span>
          {!isReadOnly && (
            <span className="flex">
              {/* <MoreActionMenu
                    menuItems={moreMenuItems}
                    icon={<MoreIcon className="text-gray-500 pt-2 mx-12" />}
                    onClickMenuItem={handleMenuItemClick}
                  /> */}
              {/* <button className="mr-4">
                    <DeleteIcon size={12} wrapperClass="text-gray-400" />
                  </button> */}
              <Tippy content={'Edit'} className="z-200">
                <button onClick={() => onExpand({ ...log, member })} className="text-gray-500">
                  ↗
                </button>
              </Tippy>
            </span>
          )}
        </div>
      </div>
      <Collapse in={!collapsed}>
        <div className="p-10 px-16 bg-gray-100 border-b border-gray-300">
          <div className="text-sm text-gray-500">{log.description || 'No description'}</div>
        </div>
      </Collapse>
    </div>
  );
};

const TimeSubmitButtons = ({
  onSave,
  disabled,
  onCancel,
  isSaving = false,
}: {
  onSave: any;
  disabled?: boolean;
  onCancel: () => void;
  isSaving?: boolean;
}) => {
  return (
    <div className="border-t px-16 py-12 flex justify-end">
      <Button onClick={onCancel} status="secondary" className="mr-16 min-w-100 flex justify-center">
        Cancel
      </Button>
      <Button
        disabled={disabled || isSaving}
        onClick={isSaving ? null : onSave}
        status="primary"
        className="min-w-100 flex justify-center"
      >
        Save
      </Button>
    </div>
  );
};
export const TimerTracker = ({
  className,
  startTime,
  stopTime,
  timeTrackedTaskId,
  isRunning,
}: {
  className?: string;
  startTime?: string;
  stopTime?: string;
  timeTrackedTaskId?: string;
  isRunning?: boolean;
}) => {
  const [showTime, setShowTime] = useState<string>('00 : 00 : 00');
  // const router = useRouter();

  const setTimer = (start: Date, stop?: Date) => {
    const now = new Date();
    const { hours, minutes, seconds } = getTimeDifference(stop ?? now, start);
    setShowTime(`${hours} : ${minutes} : ${seconds}`);
  };

  const timerCheck = () => {
    //Ensure time tracker set to 00:00 for other task views
    // TODO: Disabled temporarily since mutiple timers are now supported
    // if (router.query.taskId && timeTrackedTaskId) return router.query.taskId === timeTrackedTaskId;
    //time tacker set on navbar
    // else
    return true;
  };

  useEffect(() => {
    const timerCheckVal = timerCheck();
    if (startTime && isRunning && timerCheckVal) {
      const start = new Date(startTime);
      setTimer(start);
    }
  }, []);

  useEffect(() => {
    let interval;
    const timerCheckVal = timerCheck();
    if (startTime && isRunning && timerCheckVal) {
      interval = setInterval(() => {
        const start = new Date(startTime);
        setTimer(start);
      }, 1000);
    } else if (startTime && stopTime && !isRunning) {
      setTimer(new Date(startTime), new Date(stopTime));
    }
    return () => clearInterval(interval);
  }, [startTime, isRunning]);

  return <span className={className}>{showTime}</span>;
};

const TimeLogEdit = ({
  data,
  taskId,
  onClose,
}: {
  data: TimeLogEntry;
  taskId: string;
  onClose: () => void;
}) => {
  const [hours, setHours] = useState<number | undefined>(Number(data?.duration?.hours));
  const [minutes, setMinutes] = useState<number | undefined>(Number(data?.duration?.minutes) || 0);
  const [description, setDescription] = useState<string>(data?.description || '');
  const [startDate, setStartDate] = useState([data.startDate]);
  const [isBillable, setIsBillable] = useState<boolean>(data.billable);
  const [isSaving, setisSaving] = useState<boolean>(false);

  const boardsStore = useBoardStore();
  const fetchTask = useTasksStore((s) => s.fetchTask);

  const handleHoursInput = (e) => {
    if (e.target.value < 10000) setHours(e.target.value);
  };

  const handleMinutesInput = (e) => {
    if (e.target.value < 60) setMinutes(e.target.value);
  };

  const onSetStartDate = (dates) => {
    const dateValues = dates.length ? dates?.map((date) => formatISO(date)) : [formatISO(dates)];
    setStartDate(dateValues);
  };

  const handleUpdateEntry = async () => {
    setisSaving(true);
    try {
      const response = await API.put('/timer/timelog', {
        id: data._id,
        duration: {
          hours,
          minutes,
        },
        billable: isSaving,
        description,
      });

      if (response.data.success) {
        onClose();
        boardsStore.actions.fetchTimer();
        fetchTask(taskId);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setisSaving(false);
    }
  };

  const handleEntryDelete = async () => {
    try {
      const response = await API.delete(`/timer/timelog?id=${data._id}`);

      if (response.data.success) {
        onClose();
        boardsStore.actions.fetchTimer();
        fetchTask(taskId);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="bg-white shadow-lg rounded-md w-356">
      <header className="flex justify-between px-16 py-8 shadow-sm">
        <div className="flex items-center">
          <button className="mr-8">
            <LeftArrowIcon onClick={onClose} wrapperClass="text-gray-500" />
          </button>
          <div className="flex items-center">
            <Avatar
              src={data.member?.avatar}
              name={data.member?.firstname || ''}
              type="photo"
              wrapperClassName="mr-8"
            />
            <div className=" text-gray-500">{data.member?.firstname}</div>
          </div>
        </div>
        <button className="flex items-center" onClick={handleEntryDelete}>
          <DeleteIcon wrapperClass="mr-4 text-gray-500" />
          <span className="text-xs text-gray-500">Delete</span>
        </button>
      </header>
      <section className="p-16">
        <div className="flex mb-16">
          <div className="relative w-155 mr-8">
            <input
              id="totalEstimatedTime"
              type="number"
              min="0"
              max="10000"
              className=" bg-gray-100 p-12 pl-50 w-full placeholder-gray-400 rounded-sm h-48 border border-gray-200 text-left no-input-arrow"
              placeholder="Hours"
              autoComplete="off"
              onChange={handleHoursInput}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              value={hours}
            />
            <TimeHourglassIcon
              wrapperClass="text-gray-400 absolute p-5 top-12 left-10 left-12 border-2 border-gray-400 text-gray-400 border-dotted rounded-full"
              size={12}
            />
            <span className="absolute right-14 top-16 text-xs text-gray-500">hours</span>
          </div>
          <div className="relative w-155">
            <input
              id="totalEstimatedTime"
              type="number"
              min="0"
              max="60"
              className=" bg-gray-100 p-12 pl-50 w-full placeholder-gray-400 rounded-sm h-48 border border-gray-200 text-left no-input-arrow"
              autoComplete="off"
              onChange={handleMinutesInput}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              value={minutes}
            />
            <TimeHourglassIcon
              wrapperClass="text-gray-400 absolute p-5 top-12 left-10 left-12 border-2 border-gray-400 text-gray-400 border-dotted rounded-full"
              size={12}
            />
            <span className="absolute right-14 top-16 text-xs text-gray-500">mins</span>
          </div>
        </div>
        <StartDateSelector onSetStartDate={onSetStartDate} startDate={startDate} />
        <TimeLogDetails
          description={description}
          setDescription={setDescription}
          isBillable={isBillable}
          setIsBillable={setIsBillable}
        />
      </section>
      <TimeSubmitButtons
        disabled={!(hours || minutes) || !startDate?.length}
        onSave={handleUpdateEntry}
        onCancel={onClose}
        isSaving={isSaving}
      />
    </div>
  );
};

export const TimeTrackerDetails = ({
  isRunning,
  startTime,
  stopTime,
  setOpenTimeTracker,
  timeTrackedTaskId,
  taskId,
  taskTitle,
}: {
  taskId: string | undefined;
  startTime: string | undefined;
  stopTime: string | undefined;
  isRunning: boolean | undefined;
  setOpenTimeTracker: React.Dispatch<React.SetStateAction<boolean>>;
  timeTrackedTaskId?: string;
  taskTitle?: any;
}) => {
  const [timeRange, onChangeTimeRage] = useState([]);
  const router = useRouter();
  const item = useTasksStore(
    useCallback((s) => s.tasks[taskId as string], [router.query.taskId as string])
  );
  const [startDate, setStartDate] = useState([]);
  const [isBillable, setIsBillable] = useState<boolean>(false);
  const [stopTimeTrackModal, setStopTimeTrackModal] = useState<boolean>(false);
  const [description, setDescription] = useState<string>('');
  const [isSaving, setisSaving] = useState<boolean>(false);

  const fetchTask = useTasksStore((s) => s.fetchTask);
  const startTimer = useTasksStore((s) => s.startTimer);
  const [hours, setHours] = useState<number | undefined>();

  const [timelogDisplay, setTimelogDisplay] = useState<TimeLogEntry | any>();

  const boardsStore = useBoardStore();
  const MAX_HOUR_LIMIT = 10000;

  const { isReadOnly } = useTaskAccess(taskId || '');

  const { fetchTimers } = useTimerWidgetStore((s) => ({
    fetchTimers: s.fetchTimers,
  }));

  const onSetStartDate = (dates) => {
    const dateValues = dates.length ? dates?.map((date) => formatISO(date)) : [formatISO(dates)];
    setStartDate(dateValues);
  };
  // useEffect(() => {
  //   if (!router.query.taskId) return;
  //   console.log('fetchingTask', router.query.taskId);
  //   fetchTask(router.query.taskId as string);
  // }, [router.query.taskId as string]);
  const handleHoursInput = (e) => {
    if (e.target.value < MAX_HOUR_LIMIT) setHours(e.target.value);
  };

  const onStartTimer = async () => {
    const now = new Date().toISOString();
    // API call to start timer
    try {
      await API.post('/timer', {
        task: taskId,
        tasktype: 'board_task',
        startDate: now,
        startTime: now,
        label: [],
      });

      // if (response.data.success) {
      setStopTimeTrackModal(false);
      setOpenTimeTracker(false);
      boardsStore.actions.fetchTimer();
      startTime = now;
      isRunning = true;
      taskId && startTimer(taskId);
      fetchTimers();
      // }
    } catch (error) {
      console.log(error);
    }
  };

  const onStopTimer = async () => {
    // API call to stop timer
    const now = new Date().toISOString();
    if (isRunning && startTime) {
      const payload = {
        task: taskId,
        endTime: now,
        billable: isBillable,
        tasktype: 'board_task',
        duration: getTimeDifference(new Date(now), new Date(startTime)),
        description,
      };
      const response = await API.post('/timer/stop', payload);

      if (response.data.success && taskId) {
        boardsStore.actions.fetchTimer();
        fetchTask(taskId);
        fetchTimers();
      }
      setDescription('');
    }
  };

  const handleRangeTimeEntry = async () => {
    setisSaving(true);
    try {
      if (timeRange[0] && timeRange[1] && startDate) {
        const payload = {
          task: taskId,
          date: startDate,
          startTime: timeRange[0],
          endTime: timeRange[1],
          description,
          billable: isBillable,
        };
        const response = await API.post('timer/range', payload);

        if (response.data.success && taskId) {
          boardsStore.actions.fetchTimer();
          handleCloseTimeTracker();
          fetchTask(taskId);
        }
      }
    } finally {
      setisSaving(false);
    }
  };

  const handleManualTimeEntry = async () => {
    setisSaving(true);
    try {
      if (hours && startDate) {
        const payload = {
          task: taskId,
          description,
          billable: isBillable,
          date: startDate,
          duration: { hours },
        };
        const response = await API.post('timer/manual', payload);

        if (response.data.success && taskId) {
          fetchTask(taskId);
          boardsStore.actions.fetchTimer();
          handleCloseTimeTracker();
        }
      }
    } finally {
      setisSaving(false);
    }
  };

  const handleCloseTimeTracker = () => {
    setOpenTimeTracker(false);
    onChangeTimeRage([]);
    setStartDate([]);
    setHours(undefined);
    setDescription('');
  };

  if (timelogDisplay) {
    return (
      <TimeLogEdit
        data={timelogDisplay}
        taskId={taskId!}
        onClose={() => {
          setTimelogDisplay(null);
        }}
      />
    );
  }

  return (
    <div className="bg-white shadow-lg rounded-md w-356">
      <header className="p-16 flex justify-between text-sm bg-gray-100 mb-16 rounded-t-md">
        <span className=" text-gray-500">Time Tracked</span>
        <span className="font-medium text-gray-600">{calculateTaskTime(item, 'clock')}</span>
      </header>
      <div>
        <Tabs
          selected={0}
          onChange={() => setDescription('')}
          size="small"
          className="border-b px-16"
        >
          <Panel
            disabledMessage="You do not have the required permission to edit tasks"
            disabled={isReadOnly}
            title="Timer"
          >
            <div className="p-16">
              <div className="flex items-center mb-16">
                {isRunning && timeTrackedTaskId === router.query.taskId ? (
                  <StopCircle
                    className="mr-16 cursor-pointer hover:opacity-75"
                    onClick={onStopTimer}
                  />
                ) : (
                  <PlayCircle
                    className="mr-16 cursor-pointer hover:opacity-75"
                    onClick={() => (isRunning ? setStopTimeTrackModal(true) : onStartTimer())}
                  />
                )}

                <TimerTracker
                  className="text-2xl font-bold text-gray-500"
                  startTime={startTime}
                  stopTime={stopTime}
                  isRunning={isRunning}
                  timeTrackedTaskId={timeTrackedTaskId}
                />
              </div>
              <TimeLogDetails
                isBillable={isBillable}
                setIsBillable={setIsBillable}
                description={description}
                setDescription={setDescription}
              />
            </div>
          </Panel>
          <Panel
            disabled={isReadOnly}
            disabledMessage="You do not have the required permission to edit tasks"
            title="Manual"
          >
            <div className="p-16">
              <div className="relative mb-16">
                <input
                  id="totalEstimatedTime"
                  type="number"
                  min="0"
                  max="10000"
                  className=" bg-gray-100 p-12 pl-50 w-full placeholder-gray-400 rounded-sm h-48 border border-gray-200 text-left"
                  placeholder="Enter time in hours..."
                  autoComplete="off"
                  onChange={handleHoursInput}
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  value={hours}
                />
                <TimeHourglassIcon
                  wrapperClass="text-gray-400 absolute p-5 top-12 left-10 left-12 border-2 border-gray-400 text-gray-400 border-dotted rounded-full"
                  size={12}
                />
              </div>
              <StartDateSelector onSetStartDate={onSetStartDate} startDate={startDate} />
              <TimeLogDetails
                description={description}
                setDescription={setDescription}
                isBillable={isBillable}
                setIsBillable={setIsBillable}
              />
            </div>
            <TimeSubmitButtons
              disabled={!hours || !startDate.length}
              isSaving={isSaving}
              onSave={handleManualTimeEntry}
              onCancel={handleCloseTimeTracker}
            />
          </Panel>
          <Panel
            disabled={isReadOnly}
            disabledMessage="You do not have the required permission to edit tasks"
            title="Range"
          >
            <div className="p-16">
              <div className="relative mb-16">
                <TimeRangePicker
                  onChange={onChangeTimeRage}
                  value={timeRange}
                  disableClock={true}
                  className=" bg-gray-100 p-12 text-gray-500 w-full rounded-sm h-48 border border-gray-200 text-left"
                />
              </div>
              <StartDateSelector onSetStartDate={onSetStartDate} startDate={startDate} />
              <TimeLogDetails
                description={description}
                setDescription={setDescription}
                isBillable={isBillable}
                setIsBillable={setIsBillable}
              />
            </div>
            <TimeSubmitButtons
              disabled={timeRange?.some((t) => !t) || !startDate?.length}
              isSaving={isSaving}
              onSave={handleRangeTimeEntry}
              onCancel={handleCloseTimeTracker}
            />
          </Panel>
          <Panel title="Timelog">
            <div className="max-h-400 overflow-scroll">
              {item?.timeLog && item?.timeLog?.length > 0 ? (
                item?.timeLog?.map((user, index) => {
                  return (
                    <TimeLogEntry
                      isReadOnly={isReadOnly}
                      key={`${user.totalTimeTracked}-${index}`}
                      member={user.member}
                      logs={user.logs}
                      totalTime={user.totalTimeTracked}
                      onExpand={(e) => setTimelogDisplay(e)}
                    />
                  );
                })
              ) : (
                <div className="p-16 text-gray-999 text-sm">No time tracked yet!</div>
              )}
            </div>
          </Panel>
        </Tabs>
      </div>

      <Modal isOpen={stopTimeTrackModal} onClose={() => setStopTimeTrackModal(false)}>
        <ModalOverlay />

        <ModalContent
          style={{
            maxWidth: '46rem',
            padding: '32px',
            marginTop: '20rem',
            borderRadius: '8px',
          }}
        >
          <ModalCloseButton />
          <p className="mb-12 text-2xl font-medium text-gray-999">Start new timer?</p>
          <p className="mb-8">Here’s what happens:</p>
          <p className="mb-24">
            Your current task’s timer will be stopped and a new one will be started for this task
          </p>

          <div className="flex justify-end mt-16">
            <button
              onClick={() => setStopTimeTrackModal(false)}
              className=" text-blue-500 border rounded-sm px-24 py-13 mr-8"
            >
              Cancel
            </button>
            <button
              className=" bg-blue-500 text-white border rounded-sm px-24 py-13"
              onClick={onStartTimer}
            >
              Start timer
            </button>
          </div>
        </ModalContent>
      </Modal>
    </div>
  );
};

export const calculateTaskTime = (item: TaskT | undefined, format: 'string' | 'clock') => {
  const totalTime =
    item?.timeLog?.map((item) => item.totalTimeTracked).reduce((a, b) => a + b, 0) || 0;

  return calculateTimeInHours({ time: totalTime, format });
};
